import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ac4fd1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-language" }
const _hoisted_2 = ["value"]

import BaseIcon from '@/components/BaseIcon'

// Static translations and SelectLanguage order.

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectLanguage',
  setup(__props) {

const translations = {
  et: 'Eesti', // i18n.t('languageEt'),
  en: 'English', // i18n.t('languageEn'),
  ru: 'Русский', // i18n.t('languageRu'),
  fi: 'Suomi', //i18n.t('languageFi'),
  ja: '日本語', //i18n.t('languageJa'),
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
      class: "select-language__select"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(translations), (locale) => {
        return (_openBlock(), _createElementBlock("option", {
          key: `locale-${locale}`,
          class: "select-language__option",
          value: locale
        }, _toDisplayString(translations[locale]), 9, _hoisted_2))
      }), 128))
    ], 512), [
      [_vModelSelect, _ctx.$i18n.locale]
    ]),
    _createVNode(_unref(BaseIcon), {
      icon: "chevron-down",
      class: "select-language__icon",
      size: 16
    })
  ]))
}
}

})